<div class="view-file p-dialog-content__dynamic">
  <ng-container *ngIf="file?.url">
    <div class="d-flex mb-4 justify-content-end">
      <a [href]="file?.url" target="_blank">
        <button class="regular-btn">
          Download
        </button>
      </a>
    </div>
    <ng-container [ngSwitch]="fileType">
      <ng-container *ngSwitchCase="FileType.PDF">
        <object [data]="file?.url + '#toolbar=0&navpanes=0' | safeUrl" type="application/pdf" width="100%" height="600px"></object>
      </ng-container>
      <ng-container  *ngSwitchCase="FileType.Image">
        <img
          [src]="file?.url + ''"
          alt="Image"
          (load)="isLoading = false"
          class="img-fluid"
        />
      </ng-container>
      <div *ngSwitchDefault>
        <p>Unsupported file format</p>
      </div>
    </ng-container>
  </ng-container>
  <app-ngx-loader [loading]="isLoading" [showBackground]="false"></app-ngx-loader>

  <div *ngIf="isError" class="internal-server-error">
    Something went wrong
  </div>
</div>


<ng-template #spinner>
  <div class="full-width d-flex justify-content-center">
    <i class="fa-spin fas fa-spinner ms-2"></i>
  </div>
</ng-template>
